module.exports = __webpack_public_path__ + "img/compact.f68b1f14.png";